import { commonParams, api, ERR_OK } from './config';
import axios from '@/common/js/axiox';

/**
 * 获取课程列表
 * @param userId
 * @return {Promise<AxiosResponse<any>>}
 */
export async function getCourseList(userId) {
  return await axios.get(`${api.courseUrl}/${userId}`).then((res) => {
    return res.data;
  });
}

/**
 * 课程工具
 * @param course
 * @param types(1-新增，2-修改)
 * @return {Promise<AxiosResponse<any>>}
 */
export async function courseUtil(course, types) {
  const {
    userId,
    uuid,
    pic,
    type,
    level,
    name,
    nameEnglish,
    price,
    detail,
    status
  } = course;
  switch (types) {
    case 1:
      return await axios.post(api.courseUrl, {
        userId,
        pic,
        type,
        level,
        name,
        nameEnglish,
        price,
        detail,
        status
      }).then((res) => {
        return res.data;
      });
    case 2:
      return await axios.put(api.courseUrl, {
        userId,
        courseUUID: uuid,
        pic,
        type,
        level,
        name,
        nameEnglish,
        price,
        detail,
        status
      }).then((res) => {
        return res.data;
      });
  }

}